import { Injectable, Inject, Optional } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { Observable } from "rxjs/Observable";
import { of } from "rxjs/observable/of";
import { catchError, map, tap } from "rxjs/operators";

import { CommonService } from "./common.service";
import { MessageService } from "./message.service";

import { environment } from "../../environments/environment";

@Injectable()
export class UploadService {
  constructor(
    private http: HttpClient,
    private commonService: CommonService,
    private messageService: MessageService,
  ) {}

  private httpOptions = this.commonService.httpOptions;
  private Options = this.commonService.Options;

  /**
   *
   * アップロード設定の取得
   */
  getUpload(param: any) {
    this.commonService.loadingStart();
    return this.http
      .get(
        environment.apiUrl +
          "/api/customize/jica/upload_maintenance_list/" +
          param.eid +
          "/" +
          param.page +
          "/" +
          param.display_per_page,
        this.httpOptions,
      )
      .pipe(
        tap((Response) => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError("upload_list", [])),
      );
  }
  /**
   *
   * アップロード設定の保存
   */
  saveUpload(param: any) {
    this.commonService.loadingStart();
    return this.http
      .post(
        environment.apiUrl + "/api/customize/jica/save_upload_maintenance",
        param,
        this.Options,
      )
      .pipe(
        tap((Response) => this.commonService.loadingEnd()),
        catchError(
          this.commonService.handleError("save_upload_maintenance", []),
        ),
      );
  }
  /**
   *
   * アップロード設定の更新
   */
  updateUpload(param: any) {
    this.commonService.loadingStart();
    return this.http
      .post(
        environment.apiUrl + "/api/customize/jica/update_upload_maintenance",
        param,
        this.Options,
      )
      .pipe(
        tap((Response) => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError("updateLanguage", [])),
      );
  }

  /**
   *
   * アップロード設定を削除
   */
  deleteUpload(param: any) {
    this.commonService.loadingStart();
    return this.http
      .post(
        environment.apiUrl + "/api/customize/jica/delete_upload_maintenance",
        param,
        this.Options,
      )
      .pipe(
        tap((Response) => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError("deleteLanguage", [])),
      );
  }

  /**
   *
   * アップロード設定のソート変更
   */
  changeOrderUpload(param: any) {
    this.commonService.loadingStart();
    return this.http
      .post(
        environment.apiUrl + "/api/customize/jica/upload_maintenance_order",
        param,
        this.Options,
      )
      .pipe(
        tap((Response) => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError("updateL", [])),
      );
  }

  /**
   * 健診結果アップロード一覧の取得
   * @param {event} any ファイル選択イベント
   * @returns
   */
  getFileUploadList(param: any) {
    this.commonService.loadingStart();
    return this.http
      .get(
        environment.apiUrl +
          "/api/customize/jica/file_upload_list/" +
          param.t_event_id +
          "/" +
          param.t_person_id,
        this.httpOptions,
      )
      .pipe(
        tap((Response) => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError("file_upload_list", [])),
      );
  }

  /**
   * 健診結果アップロードファイルのダウンロード
   * @param {param} any {t_upload_file_id : 【アップロードファイルID】}
   * @returns
   */
  downloadUploadFile(param: any) {
    var request = ""; /*GETリクエスト*/
    for (var key in param) {
      if (request === "") {
        request += "?";
      } else {
        request += "&";
      }
      request += key + "=" + param[key];
    }
    request =
      environment.apiUrl +
      "/api/customize/jica/download_kekkaupload_file" +
      request;
    return this.http
      .get(request, {
        observe: "response",
        responseType: "blob",
      })
      .pipe(
        catchError(
          this.commonService.handleError("download_kekkaupload_file", []),
        ),
      );
  }

  /**
   * 健診結果アップロード
   * @param {param} any フォームデータ
   * @returns
   */
  uploadFile(param: any) {
    this.commonService.loadingStart();
    return this.http
      .post(environment.apiUrl + "/api/customize/jica/upload_file", param)
      .pipe(
        tap((Response) => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError("upload_file", [])),
      );
  }

  /**
   * 健診結果アップロード一覧の取得
   * @param {event} any ファイル選択イベント
   * @returns
   */
  // DownloadUploadFile(param: any) {
  //   this.commonService.loadingStart();
  //   return this.http
  //       .post(environment.apiUrl + "/api/customize/jica/download_upload_file/", param)
  //       .pipe(
  //         tap((Response) => this.commonService.loadingEnd()),
  //         catchError(this.commonService.handleError("download_upload_file", []))
  //       );
  // }

  DownloadUploadFile(param: any) {
    this.commonService.loadingStart();
    return this.http
      .post(
        environment.apiUrl + "/api/customize/jica/download_upload_file/",
        param,
        {
          responseType: "json",
        },
      )
      .pipe(
        tap(() => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError("download_upload_file", [])),
      );
  }

  SaikenDownloadUploadFile(param: any) {
    this.commonService.loadingStart();
    return this.http
      .post(
        environment.apiUrl + "/api/customize/jica/saiken_download_upload_file/",
        param,
        {
          responseType: "json",
        },
      )
      .pipe(
        tap(() => this.commonService.loadingEnd()),
        catchError(
          this.commonService.handleError("saiken_download_upload_file", []),
        ),
      );
  }

  PersonDownloadUploadFile(
    u_ids: string,
    su_ids: string,
    tp_id: string,
    code: string,
  ) {
    this.commonService.loadingStart();
    const param = {
      u_ids,
      su_ids,
      tp_id,
      code,
    };
    return this.http
      .post(
        environment.apiUrl + "/api/customize/jica/person_download_upload_file/",
        param,
        {
          responseType: "json",
        },
      )
      .pipe(
        tap(() => this.commonService.loadingEnd()),
        catchError(
          this.commonService.handleError("person_download_upload_file", []),
        ),
      );
  }

  /**
   * 一括ファイルダウンロード
   * @param {param} any {file_name : 【ファイルパスとzipファイルの名前】}
   * @returns
   */
  // downloadFile(param: any) {
  //   const folder = param['path'];         // 例: "20251212"
  //   const zipName = param['file_name'];  // 例: "20251212download.zip"

  //   if (!folder || !zipName) {
  //     console.error('Invalid parameters');
  //     return;
  //   }

  //   const url =
  //     environment.apiUrl +
  //     '/api/customize/jica/download_file' +
  //     '?path=' + encodeURIComponent(folder) +
  //     '&file_name=' + encodeURIComponent(zipName);

  //   window.location.href = url;
  // }

  downloadFile(param: any) {
    this.commonService.get_file(
      environment.apiUrl + "/api/customize/jica/download_file",
      param,
    );
  }

  persondownloadFile(param: any) {
    this.commonService.get_file(
      environment.apiUrl + "/api/customize/jica/person_download_file",
      param,
    );
  }

  downloadUploadBulkFile(param: any) {
    // this.commonService.loadingStart();
    return this.http
      .post(
        environment.apiUrl + "/api/customize/jica/bulk_output_start/",
        param,
        this.Options,
      )
      .pipe(
        tap((Response) => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError("updateL", [])),
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/service/upload.service.ts